import React, { useEffect, useMemo, useState } from "react";
import axios from 'axios';
import axiosInstance from '../../../axiosInstance'; import { Link } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import toast from "react-hot-toast";
import Nestable from "react-nestable";
import Gallery from "../../components/Gallery";

// page.json (state)
export const initialPage = {
  pageId: "ynb-home",
  meta: { title: "YNB Dentist" },
  sections: [
    {
      id: "hero-1",
      type: "hero",
      enabled: true,
      props: {
        badge: "YNB | Dentist",
        title: "Your smile, perfected with\ninvisible treatment",
        subPoints: ["Invisible & comfortable", "Flexible payments", "Lifestyle friendly"],
        primaryCta: { label: "Book Appointment", href: "/book" },
        image: { src: "/assets/hero.png", alt: "Hero" }
      }
    }
  ]
};

// sectionSchemas.js
export const SECTION_SCHEMAS = {
  hero: {
    label: "Hero Section",
    fields: [
      { path: "badge", label: "Badge", type: "text" },
      { path: "title", label: "Title", type: "textarea" },
      { path: "subPoints", label: "Sub Points", type: "stringArray" },

      { path: "primaryCta.label", label: "CTA Label", type: "text" },
      { path: "primaryCta.href", label: "CTA Link", type: "text" },

      { path: "image.src", label: "Image URL", type: "text" },
      { path: "image.alt", label: "Image Alt", type: "text" }
    ],
    defaultProps: {
      badge: "YNB | Dentist",
      title: "Your smile, perfected with\ninvisible treatment",
      subPoints: [],
      primaryCta: { label: "Book Appointment", href: "/book" },
      image: { src: "", alt: "" }
    }
  },

  stats: {
    label: "Stats",
    fields: [{ path: "items", label: "Stats Items", type: "keyValueArray" }],
    defaultProps: { items: [{ label: "Happy Patients", value: "30L+" }] }
  },

  faq: {
    label: "FAQ",
    fields: [{ path: "items", label: "FAQ Items", type: "qaArray" }],
    defaultProps: { items: [{ q: "Question?", a: "Answer..." }] }
  },
  
statsBar: {
    label: "Stats Bar",
    fields: [{ path: "items", label: "Stats Items", type: "keyValueArray" }],
    defaultProps: {
      items: [
        { value: "30L+", label: "Happy Patients" },
        { value: "1300+", label: "Expert Dentists" }
      ]
    }
  },

  videoCarousel: {
    label: "Video / Case Carousel",
    fields: [
      { path: "title", label: "Section Title", type: "text" },
      { path: "items", label: "Carousel Items", type: "carouselArray" }
    ],
    defaultProps: {
      title: "Discover Our Smile Transformation Work",
      items: [
        { title: "SMILE MAKEOVER SHOWCASE", subtitle: "Full Mouth Makeover", image: "", href: "", videoUrl: "" }
      ]
    }
  }
, assistGrid: {
    label: "Assist Options Grid",
    fields: [
      { path: "title", label: "Title", type: "text" },
      { path: "subtitle", label: "Subtitle", type: "text" },
      { path: "items", label: "Assist Items", type: "iconLinkArray" }
    ],
    defaultProps: {
      title: "How can we assist with your dental care today?",
      subtitle: "Select your need, then continue.",
      items: [{ label: "Regular Check-up", icon: "🦷", href: "/services/checkup" }]
    }
  },

  reviewsRow: {
    label: "Reviews Row",
    fields: [
      { path: "title", label: "Title", type: "text" },

      { path: "ratingCard.headline", label: "Rating Headline", type: "text" },
      { path: "ratingCard.rating", label: "Rating (1-5)", type: "number" },
      { path: "ratingCard.basedOnText", label: "Based On Text", type: "text" },
      { path: "ratingCard.sourceText", label: "Source (Google)", type: "text" },

      { path: "reviews", label: "Reviews", type: "reviewArray" },
      { path: "footerNote", label: "Footer Note", type: "text" },
      { path: "verifiedBadge", label: "Verified Badge", type: "text" }
    ],
    defaultProps: {
      title: "Best Dental Hospital in Delhi",
      ratingCard: { headline: "EXCELLENT", rating: 5, basedOnText: "Based on 250 reviews", sourceText: "Google" },
      reviews: [{ name: "User", rating: 5, time: "1 week ago", text: "Amazing service!", href: "" }],
      footerNote: "Showing our latest reviews",
      verifiedBadge: "Verified by Trustindex"
    }
  }
,
    qualityDentalCare: {
    label: "Quality Dental Care",
    fields: [
      { path: "topTag", label: "Top Tag", type: "text" },
      { path: "title", label: "Title", type: "text" },
      { path: "subtitle", label: "Subtitle", type: "text" },

      { path: "left.image", label: "Left Image URL", type: "text" },
      { path: "left.imageAlt", label: "Left Image Alt", type: "text" },
      { path: "left.cardTitle", label: "Left Card Title", type: "text" },
      { path: "left.cardText", label: "Left Card Text", type: "textarea" },
      { path: "left.chips", label: "Left Chips", type: "stringArray" },

      { path: "features", label: "Feature Cards", type: "featureCardArray" },

      { path: "cta.label", label: "CTA Label", type: "text" },
      { path: "cta.href", label: "CTA Link", type: "text" },
      { path: "helpText", label: "Help Text", type: "text" }
    ],
    defaultProps: {
      topTag: "Why Trust YNB",
      title: "Quality Dental Care",
      subtitle: "Select one option that best describes your need, then click “Continue”",
      left: {
        image: "/assets/quality-left.jpg",
        imageAlt: "Doctor examining patient",
        cardTitle: "Trusted Clinics. Expert Doctors.",
        cardText: "Advanced dentistry with safety-first protocols and patient-friendly care.",
        chips: ["Sterile", "Doctor Led", "Modern Tech"]
      },
      features: [
        {
          icon: "🌍",
          title: "World Class Treatment",
          subtitle: "Trusted standards that improve your experience.",
          bullets: ["Premium materials & tools", "Advanced technology", "3D intraoral scanning"]
        }
      ],
      cta: { label: "Continue", href: "/book" },
      helpText: "Need help choosing? Talk to our care team."
    }
  },

  appointmentStrip: {
    label: "Appointment Strip",
    fields: [
      { path: "title", label: "Title", type: "text" },
      { path: "subtitle", label: "Subtitle", type: "text" },

      { path: "badges", label: "Badges", type: "badgeArray" },

      { path: "fields", label: "Form Fields", type: "formFieldArray" },

      { path: "submit.label", label: "Submit Button Text", type: "text" },
      { path: "consentText", label: "Consent Text", type: "text" },
      { path: "termsHref", label: "Terms Link", type: "text" }
    ],
    defaultProps: {
      title: "Book an Appointment",
      subtitle: "Find a clinic near you in seconds",
      badges: [
        { icon: "✅", text: "Same-day slots" },
        { icon: "✅", text: "Expert doctors" },
        { icon: "✅", text: "Safe & hygienic" }
      ],
      fields: [
        { name: "fullName", label: "Full Name", type: "text", required: true, placeholder: "Full Name" },
        { name: "phone", label: "Phone Number", type: "tel", required: true, placeholder: "Phone Number" },
        { name: "city", label: "Select City", type: "select", required: true, options: ["Delhi", "Gurgaon", "Noida"] },
        { name: "captcha", label: "Captcha", type: "text", required: true, placeholder: "Captcha" }
      ],
      submit: { label: "Book Now →" },
      consentText: "By booking, you agree to our terms",
      termsHref: "/terms"
    }
  }
};

const uid = () => `${Date.now()}-${Math.random().toString(16).slice(2)}`;

function getByPath(obj, path) {
  return path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), obj);
}
function setByPath(obj, path, value) {
  const keys = path.split(".");
  const copy = structuredClone(obj);
  let cur = copy;
  for (let i = 0; i < keys.length - 1; i++) {
    const k = keys[i];
    cur[k] = cur[k] ?? {};
    cur = cur[k];
  }
  cur[keys[keys.length - 1]] = value;
  return copy;
}


const ThemeBuilder = () => {
 
   const [page, setPage] = useState(() => {
    const saved = localStorage.getItem("PAGE_JSON");
    return saved ? JSON.parse(saved) : initialPage;
  });

  const [selectedId, setSelectedId] = useState(page.sections?.[0]?.id);

  const selectedSection = useMemo(
    () => page.sections.find((s) => s.id === selectedId),
    [page, selectedId]
  );

  const schema = selectedSection ? SECTION_SCHEMAS[selectedSection.type] : null;

  // ADD section
  const addSection = (type) => {
    const def = SECTION_SCHEMAS[type];
    if (!def) return;

    const newSection = {
      id: `${type}-${uid()}`,
      type,
      enabled: true,
      props: structuredClone(def.defaultProps)
    };

    setPage((p) => ({
      ...p,
      sections: [...p.sections, newSection]
    }));

    setSelectedId(newSection.id);
  };

  // DELETE section
  const deleteSection = (id) => {
    setPage((p) => ({
      ...p,
      sections: p.sections.filter((s) => s.id !== id)
    }));
    if (selectedId === id) setSelectedId(null);
  };

  // DUPLICATE section
  const duplicateSection = (id) => {
    setPage((p) => {
      const idx = p.sections.findIndex((s) => s.id === id);
      if (idx < 0) return p;

      const copy = structuredClone(p.sections[idx]);
      copy.id = `${copy.type}-${uid()}`;

      const next = [...p.sections];
      next.splice(idx + 1, 0, copy);

      return { ...p, sections: next };
    });
  };

  // MOVE section
  const moveSection = (id, dir) => {
    setPage((p) => {
      const idx = p.sections.findIndex((s) => s.id === id);
      if (idx < 0) return p;

      const newIdx = dir === "up" ? idx - 1 : idx + 1;
      if (newIdx < 0 || newIdx >= p.sections.length) return p;

      const next = [...p.sections];
      const [item] = next.splice(idx, 1);
      next.splice(newIdx, 0, item);

      return { ...p, sections: next };
    });
  };

  // EDIT section props (by schema fields)
  const updateField = (path, value) => {
    setPage((p) => {
      const nextSections = p.sections.map((s) => {
        if (s.id !== selectedId) return s;
        return { ...s, props: setByPath(s.props, path, value) };
      });

      return { ...p, sections: nextSections };
    });
  };

  // SAVE (local + API)
  const savePage = async () => {
    localStorage.setItem("PAGE_JSON", JSON.stringify(page));

    // Example API save
    // await fetch("/api/pages/save", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(page)
    // });

    alert("Saved JSON ✅");
  };

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
 
    <div style={{ display: "grid", gridTemplateColumns: "320px 420px 1fr", gap: 12 }}>
      {/* Left: Sections list */}
      <div style={panel}>
        <h3>Sections</h3>

        {page.sections.map((s) => (
          <div
            key={s.id}
            onClick={() => setSelectedId(s.id)}
            style={{
              ...row,
              border: selectedId === s.id ? "2px solid #111" : "1px solid #ddd"
            }}
          >
            <div>
              <b>{SECTION_SCHEMAS[s.type]?.label || s.type}</b>
              <div style={{ fontSize: 12, opacity: 0.7 }}>{s.id}</div>
            </div>

            <div style={{ display: "flex", gap: 6 }}>
              <button onClick={(e) => (e.stopPropagation(), moveSection(s.id, "up"))}>↑</button>
              <button onClick={(e) => (e.stopPropagation(), moveSection(s.id, "down"))}>↓</button>
            </div>
          </div>
        ))}

        <hr />

        <h4>Add Section</h4>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {Object.keys(SECTION_SCHEMAS).map((type) => (
            <button key={type} onClick={() => addSection(type)}>
              + {SECTION_SCHEMAS[type].label}
            </button>
          ))}
        </div>

        <hr />
        <button onClick={savePage} style={{ width: "100%" }}>
          Save Page JSON
        </button>
      </div>

      {/* Middle: Editor */}
      <div style={panel}>
        <h3>Editor</h3>

        {!selectedSection ? (
          <div>Select a section</div>
        ) : (
          <>
            <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
              <button onClick={() => duplicateSection(selectedSection.id)}>Duplicate</button>
              <button onClick={() => deleteSection(selectedSection.id)}>Delete</button>
            </div>

            <div style={{ marginBottom: 10 }}>
              <label>
                <input
                  type="checkbox"
                  checked={selectedSection.enabled !== false}
                  onChange={(e) =>
                    setPage((p) => ({
                      ...p,
                      sections: p.sections.map((s) =>
                        s.id === selectedSection.id ? { ...s, enabled: e.target.checked } : s
                      )
                    }))
                  }
                />{" "}
                Enabled
              </label>
            </div>

            {schema?.fields?.map((f) => (
              <DynamicField
                key={f.path}
                field={f}
                value={getByPath(selectedSection.props, f.path)}
                onChange={(val) => updateField(f.path, val)}
              />
            ))}
          </>
        )}
      </div>

      {/* Right: Live Preview */}
      <div style={panel}>
        <h3>Live Preview</h3>
        {/* <PageRenderer page={page} /> */}
      </div>
    </div>


      </main >
    </>
  );
};


function DynamicField({ field, value, onChange }) {
  const { label, type } = field;

  if (type === "textarea") {
    return (
      <div style={fieldWrap}>
        <div style={fieldLabel}>{label}</div>
        <textarea value={value || ""} onChange={(e) => onChange(e.target.value)} rows={4} />
      </div>
    );
  }

  if (type === "stringArray") {
    const arr = Array.isArray(value) ? value : [];
    return (
      <div style={fieldWrap}>
        <div style={fieldLabel}>{label}</div>
        {arr.map((v, i) => (
          <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
            <input
              value={v}
              onChange={(e) => {
                const next = [...arr];
                next[i] = e.target.value;
                onChange(next);
              }}
            />
            <button
              onClick={() => {
                const next = arr.filter((_, idx) => idx !== i);
                onChange(next);
              }}
            >
              ✕
            </button>
          </div>
        ))}
        <button onClick={() => onChange([...arr, ""])}>+ Add</button>
      </div>
    );
  }

  // stats / keyValue array
  if (type === "keyValueArray") {
    const arr = Array.isArray(value) ? value : [];
    return (
      <div style={fieldWrap}>
        <div style={fieldLabel}>{label}</div>
        {arr.map((it, i) => (
          <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 6, marginBottom: 6 }}>
            <input
              placeholder="Label"
              value={it.label || ""}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], label: e.target.value };
                onChange(next);
              }}
            />
            <input
              placeholder="Value"
              value={it.value || ""}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], value: e.target.value };
                onChange(next);
              }}
            />
            <button onClick={() => onChange(arr.filter((_, idx) => idx !== i))}>✕</button>
          </div>
        ))}
        <button onClick={() => onChange([...arr, { label: "", value: "" }])}>+ Add</button>
      </div>
    );
  }

  // faq array
  if (type === "qaArray") {
    const arr = Array.isArray(value) ? value : [];
    return (
      <div style={fieldWrap}>
        <div style={fieldLabel}>{label}</div>
        {arr.map((it, i) => (
          <div key={i} style={{ border: "1px solid #ddd", borderRadius: 10, padding: 10, marginBottom: 8 }}>
            <input
              placeholder="Question"
              value={it.q || ""}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], q: e.target.value };
                onChange(next);
              }}
              style={{ width: "100%", marginBottom: 6 }}
            />
            <textarea
              placeholder="Answer"
              value={it.a || ""}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], a: e.target.value };
                onChange(next);
              }}
              rows={3}
              style={{ width: "100%" }}
            />
            <button onClick={() => onChange(arr.filter((_, idx) => idx !== i))} style={{ marginTop: 6 }}>
              Remove
            </button>
          </div>
        ))}
        <button onClick={() => onChange([...arr, { q: "", a: "" }])}>+ Add FAQ</button>
      </div>
    );
  }

  // inside DynamicField()
if (type === "carouselArray") {
  const arr = Array.isArray(value) ? value : [];
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 8 }}>{label}</div>

      {arr.map((it, i) => (
        <div key={i} style={{ border: "1px solid #ddd", borderRadius: 12, padding: 10, marginBottom: 10 }}>
          <input
            placeholder="Title"
            value={it.title || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], title: e.target.value };
              onChange(next);
            }}
            style={{ width: "100%", marginBottom: 6 }}
          />
          <input
            placeholder="Subtitle"
            value={it.subtitle || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], subtitle: e.target.value };
              onChange(next);
            }}
            style={{ width: "100%", marginBottom: 6 }}
          />
          <input
            placeholder="Image URL"
            value={it.image || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], image: e.target.value };
              onChange(next);
            }}
            style={{ width: "100%", marginBottom: 6 }}
          />
          <input
            placeholder="Video URL"
            value={it.videoUrl || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], videoUrl: e.target.value };
              onChange(next);
            }}
            style={{ width: "100%", marginBottom: 6 }}
          />
          <input
            placeholder="Link (href)"
            value={it.href || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], href: e.target.value };
              onChange(next);
            }}
            style={{ width: "100%" }}
          />

          <button
            onClick={() => onChange(arr.filter((_, idx) => idx !== i))}
            style={{ marginTop: 8 }}
          >
            Remove Item
          </button>
        </div>
      ))}

      <button
        onClick={() =>
          onChange([...arr, { title: "", subtitle: "", image: "", videoUrl: "", href: "" }])
        }
      >
        + Add Carousel Item
      </button>
    </div>
  );
}

if (type === "iconLinkArray") {
  const arr = Array.isArray(value) ? value : [];
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 8 }}>{label}</div>

      {arr.map((it, i) => (
        <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr auto", gap: 6, marginBottom: 6 }}>
          <input
            placeholder="Label"
            value={it.label || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], label: e.target.value };
              onChange(next);
            }}
          />
          <input
            placeholder="Icon (emoji)"
            value={it.icon || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], icon: e.target.value };
              onChange(next);
            }}
          />
          <input
            placeholder="Link (href)"
            value={it.href || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], href: e.target.value };
              onChange(next);
            }}
          />
          <button onClick={() => onChange(arr.filter((_, idx) => idx !== i))}>✕</button>
        </div>
      ))}

      <button onClick={() => onChange([...arr, { label: "", icon: "", href: "" }])}>+ Add Item</button>
    </div>
  );
}

// reviewArray
if (type === "reviewArray") {
  const arr = Array.isArray(value) ? value : [];
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 8 }}>{label}</div>

      {arr.map((it, i) => (
        <div key={i} style={{ border: "1px solid #ddd", borderRadius: 12, padding: 10, marginBottom: 10 }}>
          <input
            placeholder="Name"
            value={it.name || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], name: e.target.value };
              onChange(next);
            }}
            style={{ width: "100%", marginBottom: 6 }}
          />
          <input
            placeholder="Time (e.g. 2 weeks ago)"
            value={it.time || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], time: e.target.value };
              onChange(next);
            }}
            style={{ width: "100%", marginBottom: 6 }}
          />
          <input
            placeholder="Rating (1-5)"
            value={it.rating || 5}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], rating: Number(e.target.value) || 5 };
              onChange(next);
            }}
            style={{ width: "100%", marginBottom: 6 }}
          />
          <textarea
            placeholder="Review text"
            value={it.text || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], text: e.target.value };
              onChange(next);
            }}
            rows={3}
            style={{ width: "100%", marginBottom: 6 }}
          />
          <input
            placeholder="Read more link"
            value={it.href || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], href: e.target.value };
              onChange(next);
            }}
            style={{ width: "100%" }}
          />

          <button onClick={() => onChange(arr.filter((_, idx) => idx !== i))} style={{ marginTop: 8 }}>
            Remove Review
          </button>
        </div>
      ))}

      <button onClick={() => onChange([...arr, { name: "", time: "", rating: 5, text: "", href: "" }])}>
        + Add Review
      </button>
    </div>
  );
}

if (type === "featureCardArray") {
  const arr = Array.isArray(value) ? value : [];
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 8 }}>{label}</div>

      {arr.map((it, i) => (
        <div key={i} style={{ border: "1px solid #ddd", borderRadius: 12, padding: 10, marginBottom: 10 }}>
          <div style={{ display: "grid", gridTemplateColumns: "120px 1fr", gap: 8 }}>
            <input
              placeholder="Icon (emoji)"
              value={it.icon || ""}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], icon: e.target.value };
                onChange(next);
              }}
            />
            <input
              placeholder="Title"
              value={it.title || ""}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], title: e.target.value };
                onChange(next);
              }}
            />
          </div>

          <input
            placeholder="Subtitle"
            value={it.subtitle || ""}
            onChange={(e) => {
              const next = [...arr];
              next[i] = { ...next[i], subtitle: e.target.value };
              onChange(next);
            }}
            style={{ width: "100%", marginTop: 6 }}
          />

          {/* bullets */}
          <div style={{ marginTop: 8, fontWeight: 800, fontSize: 12, opacity: 0.8 }}>Bullets</div>
          {(Array.isArray(it.bullets) ? it.bullets : []).map((b, bi) => (
            <div key={bi} style={{ display: "flex", gap: 6, marginTop: 6 }}>
              <input
                value={b}
                placeholder="Bullet text"
                onChange={(e) => {
                  const next = [...arr];
                  const bullets = [...(next[i].bullets || [])];
                  bullets[bi] = e.target.value;
                  next[i] = { ...next[i], bullets };
                  onChange(next);
                }}
                style={{ flex: 1 }}
              />
              <button
                onClick={() => {
                  const next = [...arr];
                  const bullets = (next[i].bullets || []).filter((_, x) => x !== bi);
                  next[i] = { ...next[i], bullets };
                  onChange(next);
                }}
              >
                ✕
              </button>
            </div>
          ))}

          <button
            onClick={() => {
              const next = [...arr];
              const bullets = [...(next[i].bullets || []), ""];
              next[i] = { ...next[i], bullets };
              onChange(next);
            }}
            style={{ marginTop: 8 }}
          >
            + Add Bullet
          </button>

          <button
            onClick={() => onChange(arr.filter((_, idx) => idx !== i))}
            style={{ marginTop: 10 }}
          >
            Remove Card
          </button>
        </div>
      ))}

      <button
        onClick={() =>
          onChange([...arr, { icon: "⭐", title: "", subtitle: "", bullets: [""] }])
        }
      >
        + Add Feature Card
      </button>
    </div>
  );
}

if (type === "formFieldArray") {
  const arr = Array.isArray(value) ? value : [];
  const fieldTypes = ["text", "tel", "email", "select", "textarea", "number"];

  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 8 }}>{label}</div>

      {arr.map((it, i) => (
        <div key={i} style={{ border: "1px solid #ddd", borderRadius: 12, padding: 10, marginBottom: 10 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
            <input
              placeholder="name (unique key)"
              value={it.name || ""}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], name: e.target.value };
                onChange(next);
              }}
            />
            <input
              placeholder="Label"
              value={it.label || ""}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], label: e.target.value };
                onChange(next);
              }}
            />
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 8 }}>
            <select
              value={it.type || "text"}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], type: e.target.value };
                onChange(next);
              }}
            >
              {fieldTypes.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>

            <input
              placeholder="Placeholder"
              value={it.placeholder || ""}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], placeholder: e.target.value };
                onChange(next);
              }}
            />
          </div>

          <label style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 8 }}>
            <input
              type="checkbox"
              checked={!!it.required}
              onChange={(e) => {
                const next = [...arr];
                next[i] = { ...next[i], required: e.target.checked };
                onChange(next);
              }}
            />
            Required
          </label>

          {/* select options */}
          {it.type === "select" && (
            <div style={{ marginTop: 10 }}>
              <div style={{ fontWeight: 800, fontSize: 12, opacity: 0.8 }}>Options</div>
              {(Array.isArray(it.options) ? it.options : []).map((op, oi) => (
                <div key={oi} style={{ display: "flex", gap: 6, marginTop: 6 }}>
                  <input
                    value={op}
                    placeholder="Option"
                    onChange={(e) => {
                      const next = [...arr];
                      const opts = [...(next[i].options || [])];
                      opts[oi] = e.target.value;
                      next[i] = { ...next[i], options: opts };
                      onChange(next);
                    }}
                    style={{ flex: 1 }}
                  />
                  <button
                    onClick={() => {
                      const next = [...arr];
                      const opts = (next[i].options || []).filter((_, x) => x !== oi);
                      next[i] = { ...next[i], options: opts };
                      onChange(next);
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))}

              <button
                onClick={() => {
                  const next = [...arr];
                  const opts = [...(next[i].options || []), ""];
                  next[i] = { ...next[i], options: opts };
                  onChange(next);
                }}
                style={{ marginTop: 8 }}
              >
                + Add Option
              </button>
            </div>
          )}

          <button onClick={() => onChange(arr.filter((_, idx) => idx !== i))} style={{ marginTop: 10 }}>
            Remove Field
          </button>
        </div>
      ))}

      <button
        onClick={() =>
          onChange([
            ...arr,
            { name: `field_${arr.length + 1}`, label: "New Field", type: "text", required: false, placeholder: "" }
          ])
        }
      >
        + Add Field
      </button>
    </div>
  );
}

  // default text
  return (
    <div style={fieldWrap}>
      <div style={fieldLabel}>{label}</div>
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}

const panel = {
  background: "#fff",
  border: "1px solid #e7e7e7",
  borderRadius: 14,
  padding: 12,
  height: "calc(100vh - 24px)",
  overflow: "auto"
};
const row = {
  padding: 10,
  borderRadius: 12,
  marginBottom: 8,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer"
};
const fieldWrap = { marginBottom: 12, display: "grid", gap: 6 };
const fieldLabel = { fontSize: 12, fontWeight: 700, opacity: 0.8 };


export default ThemeBuilder;
